import { error } from "./error";
/**
 * Compare array of objects, sort by object value (number).
 * @param {*} a
 * @param {*} b
 */
function decendingSort(a, b) {
  try {
    if (typeof a !== "number" || typeof b !== "number") {
      throw error(`Object property in Array must be of type 'number'`);
    }
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }

    return 0;
  } catch (e) {
    console.error(e);
  }
}

/**
 * Compare array of objects, reverse sort by object value (number).
 * @param {*} a
 * @param {*} b
 */
function ascendingSort(a, b) {
  try {
    if (typeof a !== "number" || typeof b !== "number") {
      throw error(`Object property in Array must be of type 'number'`);
    }
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }

    return 0;
  } catch (e) {
    console.error(e);
  }
}

/**
 * Sort list of objects by key or compare a list of strings
 * @param {*} list
 * @param {*} key
 * @returns sorted list
 */
function sortListAlphabetically(list, key) {
  if (key) {
    return [...list.sort((a, b) => a[key].localeCompare(b[key]))];
  }

  return [...list.sort((a, b) => a.localeCompare(b))];
}

export { ascendingSort, decendingSort, sortListAlphabetically };
